// FOC-491 AC1 — Store en memoria del token temporal purpose=otp_pending.
//
// Emitido por /api/user/authentication cuando user.enabledOtp=true, para
// gatillar la validación de OTP ANTES del device check. El token vive 15
// min, SOLO en memoria: una recarga de la página lo pierde a propósito.
//
// Mismo patrón que deviceVerification.js (FOC-492).

const DEFAULT_EXPIRES_IN_SECONDS = 15 * 60

let pending = null

export const startOtpPending = (data) => {
  const now = Date.now()
  const expiresIn = data.expiresIn ?? DEFAULT_EXPIRES_IN_SECONDS
  pending = {
    token: data.otpPendingToken,
    maskedEmail: data.maskedEmail,
    expiresAt: now + (expiresIn * 1000)
  }
}

export const getOtpPending = () => {
  if (!pending) return null
  if (Date.now() >= pending.expiresAt) {
    pending = null

    return null
  }

  return pending
}

export const getOtpPendingToken = () => {
  const p = getOtpPending()

  return p?.token ?? null
}

export const clearOtpPending = () => {
  pending = null
}
